<!--
File: product-toolbar-search-info.component.html
Project: catalog-cloud
File Created: Sunday, 6th March 2022 23:00:15
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Saturday, 15th March 2026
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<div class="ptsi-row">
  <span class="ptsi-count">
    <b>{{ filteredProducts }}</b><span class="ptsi-count-sep">/</span>{{ allProducts }}
  </span>
  <div class="ptsi-actions">
    <p-button
      *ngFor="let view of viewOptions"
      styleClass="n-button-icon-xs"
      [icon]="view.icon"
      (click)="changeViewType(view.value)"
      [severity]="selectedView === view.value ? 'success' : 'secondary'"
      [text]="true"
      [raised]="true"
    />
  </div>
</div>
